// extracted by mini-css-extract-plugin
module.exports = {"slide":"List_slide_1X53q","slide-reverse":"List_slide-reverse_1HT3H","table":"List_table_ldi9i","marginContent":"List_marginContent_1ybuY"};